<template>
	<div>
		<div v-if="show==true" class="gray">
			<div v-if="!view" class="dialog">
				<div style="display:inline-block; width:100%;">
					<p class="title">Add Comment to Job Order {{joborderid}}</p>
					<p class="cancel" v-on:click="cancel()"><font-awesome-icon icon="times" /></p>
				</div>
				<hr/>
				<div style="display:inline-block; width:100%;">
					<textarea id="commentInput" style="width:100%; min-height:30px;" v-model="comment"></textarea>
				</div>
				<hr/>
				<div style="display:inline-block; width:100%;">
					<button class="buttons" v-on:click="cancel()">Cancel</button>
					<button class="buttons" v-on:click="save()">Add</button>
				</div>
			</div>

            <div v-else class="dialog">
				<div style="display:inline-block; width:100%;">
					<p class="title">Job Order {{joborderid}} Comments</p>
					<p class="cancel" v-on:click="cancel()"><font-awesome-icon icon="times" /></p>
				</div>
				<hr/>
				<div style="display:inline-block; width:100%;">
					<layout-1 
                        style="height:50vh; width:70vw;"
                        :table_name="'Comments'"
                        :id=pageid 
                        :searchbar=false 
                        :height_limit="true"
                        :navbar=false 
                        :select_reroute=false 
                        :button_perm="'118'"
                        :button_name="'Delete'"
                        :term="'11-'+joborderid"
                        :key=commentsKey
                        v-on:select="deleteComment">
                    </layout-1>
				</div>
				<hr/>
				<div style="display:inline-block; width:100%;">
					<button class="buttons" v-on:click="cancel()">Close</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
import {PAGES} from './../../constants.js'
export default {
    props: {
		joborderid: {
			type: Number
		},
		show: {
			type: Boolean,
			required:false,
			default:true,
		},
		view: {
			type: Boolean,
			required:false,
			default:false,
		},
    },
	data() {
		return {
			pageid: PAGES.JOBORDER_COMMENTS_PAGE,
			pageid2: PAGES.JOBORDER_COMMENTS_DELETE_PAGE,
			comment:'',
            commentsKey:0,
		}
	},
	async created () {
		this.comment = '';
	},
	methods: {
		async save() {
			if(this.comment == '') {
				this.cancel();
				return;
			}

			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid,
						term:this.joborderid,
						data:[this.comment],
					}
				}
			).then((res) => {
				if(res.data.errors!=undefined) {
					alert("error")
			    }else {
					this.$emit('save',this.comment);
			    }
			}).finally(() => {
				this.cancel();
			});
		},
		async cancel() {
			this.comment = '';
			this.$emit('cancel');
		},
		deleteComment(col, term) {
            api.postData(
				{
					type:"insert",
					data:{
						pageid:this.pageid2,
						data:[col[0]],
					}
				}
			).then((res) => {
				if(res.data.errors!=undefined) {
					alert("error")
			    }else {
                    this.commentsKey++;
                    alert("Comment deleted")
			    }
			})
		},  
	},
	watch:{
		show(){
			this.$nextTick(function () {
				if(this.show && !this.view) {
					this.comment = '';
					var input = document.getElementById('commentInput');
					input.focus();
					input.select();
				}
			})
		},
	}
}
</script>

<style scoped>

.dialog{
	position:fixed;
	background-color:white;
	left: 50%;
	top:20vh;
	min-width:500px;
	transform: translateX(-50%);
	padding:15px;
	border:1px solid black;
	border-radius: 5px;
	box-shadow: 2px 2px;
}

.title{
	font-size: 40px;
	font-weight: bold;
	float:left;
	margin:0px;
}

.cancel{
	float:right;
	width:30px;
	text-align: center;
	font-size:24px;
}
.cancel:hover{
	color:#5c5e70;
}

.paragraph{
	font-size:22px;
	margin:0px;
	white-space: pre-wrap;
}

.buttons{
	float:right;
	font-size:18px;
}

.gray {
	display: absolute;
	position: fixed;
	z-index: 2;
	padding-top: 100px;
	left: 0;
	top: 0;
	width:100%;
	height:100%;
	overflow:auto;
	background-color: rgba(0,0,0,0.5);
}

.textfield{
    width:100%;
	height:150px;
	min-height:75px;
	max-height:375px;
}

</style>



// WEBPACK FOOTER //
// src/layouts/comments.vue